import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cfg-foxbit',
  templateUrl: './cfg-foxbit.component.html',
  styleUrls: ['./cfg-foxbit.component.scss']
})
export class CfgFoxbitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
